<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';

const b = bem('new-user-modal');
export default {
  data() {
    return {
      open: false,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createUserAction: 'users/createUser',
    }),
    showModal() {
      this.open = true;
    },
    async handleOk(values) {
      await this.createUserAction(values);
      this.open = false;
      setTimeout(() => {
        this.$emit('user-created');
      }, 500);
    },
  },
};
</script>

<template>
  <div>
    <a-button type="primary" @click="showModal">Create user</a-button>
    <a-modal v-model:open="open" :footer="null" >
      <FormKit
          type="form"
          submit-label="Register"
          @submit="handleOk"
      >
        <h1 class="text-2xl font-bold mb-2">Register new account</h1>
        <FormKit
            type="text"
            name="firstName"
            label="First name"
            placeholder="First name"
            validation="required"
        />
        <FormKit
            type="text"
            name="lastName"
            label="Last name"
            placeholder="Last name"
            validation="required"
        />
        <FormKit
            type="text"
            name="email"
            label="Email"
            placeholder="Email"
            validation="required|email"
        />
      </FormKit>
    </a-modal>
  </div>
</template>
